module.exports = "/_next/static/images/loading_10-3cd1a6659d81e7aea6d8421626e01c7b.png";